import type { CSSProperties } from 'react';

interface Feather {
  left: string;
  delay: string;
  duration: string;
  drift: string;
  extra?: boolean;
}

const FEATHERS: Feather[] = [
  { left: '18%', delay: '0s', duration: '6.4s', drift: '10px' },
  { left: '36%', delay: '1.6s', duration: '7.2s', drift: '-14px' },
  { left: '58%', delay: '0.8s', duration: '6.8s', drift: '16px' },
  { left: '74%', delay: '2.4s', duration: '7.6s', drift: '-8px' },
  { left: '88%', delay: '1.2s', duration: '6.2s', drift: '12px' },
  { left: '26%', delay: '2.1s', duration: '5.8s', drift: '-12px', extra: true },
  { left: '48%', delay: '0.4s', duration: '6.6s', drift: '8px', extra: true },
  { left: '66%', delay: '1.9s', duration: '7.1s', drift: '-16px', extra: true },
  { left: '82%', delay: '3s', duration: '6s', drift: '14px', extra: true },
];

export function DivineFx({ motes, rich }: { motes: boolean; rich: boolean }) {
  return (
    <span className="fx fx--divine" aria-hidden="true">
      {rich && <span className="fx__rose" />}
      <span className="fx__pillar" />
      <span className="fx__corona" />
      <span className="fx__corona fx__corona--counter" />
      <span className="fx__rays" />
      <span className="fx__dawn" />
      {motes && (
        <span className="fx__feathers">
          {FEATHERS.map((feather, index) => (
            <i
              key={index}
              className={feather.extra ? 'is-extra' : undefined}
              style={
                {
                  '--x': feather.left,
                  '--delay': feather.delay,
                  '--time': feather.duration,
                  '--drift': feather.drift,
                } as CSSProperties
              }
            />
          ))}
        </span>
      )}
    </span>
  );
}
